<template>
  <div id="app">
    <pageTop v-if="!$route.meta.hideHeader"></pageTop>
    <router-view :key="$route.fullpath" class="flex-container" />
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
export default {
  components:{pageTop},
  name: "App",
};
</script>

<style>
@import url("assets/css/reset.scss");

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  overflow: hidden;
}

.text_indent_2{
  text-indent: 46px;
}

@media screen and (max-width: 1000px) {
  .media_font_size_50 {
    font-size: 50px !important;
  }
  .media_font_size_30 {
    font-size: 30px !important;
  }
  .media_font_size_20 {
    font-size: 20px !important;
  }
  .media_font_size_70 {
    font-size: 70px !important;
  }
}

@media screen and (min-width: 100px) and (max-width: 1000px) {
  /* padding */
  .pt-20 {
    padding-top: 60px;
  }
  .pt-30 {
    padding-top: 90px;
  }
  .pt-40 {
    padding-top: 120px;
  }
  .pt-50 {
    padding-top: 150px;
  }
  .pt-60 {
    padding-top: 180px;
  }

  .pr-20 {
    padding-right: 60px;
  }
  .pr-30 {
    padding-right: 90px;
  }
  .pr-40 {
    padding-right: 120px;
  }
  .pr-50 {
    padding-right: 150px;
  }
  .pr-60 {
    padding-right: 180px;
  }

  .pb-20 {
    padding-bottom: 60px;
  }
  .pb-30 {
    padding-bottom: 90px;
  }
  .pb-40 {
    padding-bottom: 120px;
  }
  .pb-50 {
    padding-bottom: 150px;
  }
  .pb-60 {
    padding-bottom: 180px;
  }

  .pl-20 {
    padding-left: 60px;
  }
  .pl-30 {
    padding-left: 90px;
  }
  .pl-40 {
    padding-left: 120px;
  }
  .pl-50 {
    padding-left: 150px;
  }
  .pl-60 {
    padding-left: 180px;
  }

  /* margin */
  .mt-20 {
    margin-top: 60px;
  }
  .mt-30 {
    margin-top: 90px;
  }
  .mt-40 {
    margin-top: 120px;
  }
  .mt-50 {
    margin-top: 150px;
  }
  .mt-60 {
    margin-top: 180px;
  }

  .mr-10 {
    margin-right: 30px;
  }
  .mr-20 {
    margin-right: 60px;
  }
  .mr-30 {
    margin-right: 90px;
  }
  .mr-40 {
    margin-right: 120px;
  }
  .mr-50 {
    margin-right: 150px;
  }
  .mr-60 {
    margin-right: 180px;
  }

  .mb-20 {
    margin-bottom: 60px;
  }
  .mb-30 {
    margin-bottom: 90px;
  }
  .mb-40 {
    margin-bottom: 120px;
  }
  .mb-50 {
    margin-bottom: 150px;
  }
  .mb-60 {
    margin-bottom: 180px;
  }

  .ml-20 {
    margin-left: 60px;
  }
  .ml-30 {
    margin-left: 90px;
  }
  .ml-40 {
    margin-left: 120px;
  }
  .ml-50 {
    margin-left: 150px;
  }
  .ml-60 {
    margin-left: 180px;
  }

  /* font-size */
  .fs-40 {
    font-size: 120px;
    line-height: 160px;
  }
  .fs-36 {
    font-size: 108px;
    line-height: 144px;
  }
  .fs-30 {
    font-size: 90px;
    line-height: 120px;
  }
  .fs-24 {
    font-size: 72px;
    line-height: 90px;
  }
  .fs-20 {
    font-size: 60px;
    line-height: 80px;
  }
  .fs-16 {
    font-size: 48px;
    line-height: 72px;
  }
  .fs-14 {
    font-size: 42px;
    line-height: 63px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  /* padding */
  .pt-20 {
    padding-top: 20px;
  }
  .pt-30 {
    padding-top: 30px;
  }
  .pt-40 {
    padding-top: 40px;
  }
  .pt-50 {
    padding-top: 50px;
  }
  .pt-60 {
    padding-top: 60px;
  }

  .pr-20 {
    padding-right: 20px;
  }
  .pr-30 {
    padding-right: 30px;
  }
  .pr-40 {
    padding-right: 40px;
  }
  .pr-50 {
    padding-right: 50px;
  }
  .pr-60 {
    padding-right: 60px;
  }

  .pb-20 {
    padding-bottom: 20px;
  }
  .pb-30 {
    padding-bottom: 30px;
  }
  .pb-40 {
    padding-bottom: 40px;
  }
  .pb-50 {
    padding-bottom: 50px;
  }
  .pb-60 {
    padding-bottom: 60px;
  }

  .pl-20 {
    padding-left: 20px;
  }
  .pl-30 {
    padding-left: 30px;
  }
  .pl-40 {
    padding-left: 40px;
  }
  .pl-50 {
    padding-left: 50px;
  }
  .pl-60 {
    padding-left: 60px;
  }

  /* margin */
  .mt-20 {
    margin-top: 20px;
  }
  .mt-30 {
    margin-top: 30px;
  }
  .mt-40 {
    margin-top: 40px;
  }
  .mt-50 {
    margin-top: 50px;
  }
  .mt-60 {
    margin-top: 60px;
  }

  .mr-10 {
    margin-right: 10px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .mr-30 {
    margin-right: 30px;
  }
  .mr-40 {
    margin-right: 40px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .mr-60 {
    margin-right: 60px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-50 {
    margin-bottom: 50px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }

  .ml-20 {
    margin-left: 20px;
  }
  .ml-30 {
    margin-left: 30px;
  }
  .ml-40 {
    margin-left: 40px;
  }
  .ml-50 {
    margin-left: 50px;
  }
  .ml-60 {
    margin-left: 60px;
  }

  /* font-size */
  .fs-40 {
    font-size: 40px;
    line-height: 60px;
  }
  .fs-36 {
    font-size: 36px;
    line-height: 48px;
  }
  .fs-30 {
    font-size: 30px;
    line-height: 40px;
  }
  .fs-24 {
    font-size: 24px;
    line-height: 32px;
  }
  .fs-20 {
    font-size: 20px;
    line-height: 30px;
  }
  .fs-16 {
    font-size: 16px;
    line-height: 24px;
  }
  .fs-14 {
    font-size: 14px;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?981b56c2